var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlinePin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: "auto",
    viewBox: "0 0 57 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 9.9V34.65C36.5 40.194 37.98 45.342 40.5 49.5H16.5C19.1 45.243 20.5 40.095 20.5 34.65V9.9H36.5ZM48.5 0H8.5C6.3 0 4.5 2.2275 4.5 4.95C4.5 7.6725 6.3 9.9 8.5 9.9H12.5V34.65C12.5 41.3018 8.98753 46.9155 4.12697 48.8129C2.21698 49.5584 0.5 51.1621 0.5 53.2125V53.2125C0.5 56.6298 3.27024 59.4 6.6875 59.4H24.38V94.05L28.38 99L32.38 94.05V59.4H50.3125C53.7298 59.4 56.5 56.6298 56.5 53.2125V53.2125C56.5 51.1621 54.783 49.5584 52.873 48.8129C48.0125 46.9155 44.5 41.3018 44.5 34.65V9.9H48.5C50.7 9.9 52.5 7.6725 52.5 4.95C52.5 2.2275 50.7 0 48.5 0Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinePin);
export default __webpack_public_path__ + "static/media/outlinePin.2ac9cd77c65c72c133f930cb6f377489.svg";
export { ForwardRef as ReactComponent };